<template lang="pug">
  .player
    video(:src="src" @enterpictureinpicture="enterPIP"
      @leavepictureinpicture="leavePIP"
      controls ref="video" controlsList="nodownload")
      button.closeBtn(@click="close")
    .model(@click="close")
</template>

<script>
  import {isPhone} from "@/utils/utils";

  export default {
    name: "videoPlayer",
    data() {
      return {
        src: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E8%A7%86%E9%A2%91/1080p-3.mov',
      };
    },
    methods: {
      exitFullScreen() {
        const de = this.$refs['video'];
        if (de.exitFullscreen) {
          de.exitFullscreen();
        } else if (de.mozCancelFullScreen) {
          de.mozCancelFullScreen();
        } else if (de.webkitCancelFullScreen) {
          de.webkitCancelFullScreen();
        }
      },
      fullScreen() {
        const ele = this.$refs['video'];
        if (ele .requestFullscreen) {
          ele .requestFullscreen();
        } else if (ele .mozRequestFullScreen) {
          ele .mozRequestFullScreen();
        } else if (ele .webkitRequestFullScreen) {
          ele .webkitRequestFullScreen();
        }
      },
      play() {
        if (isPhone()) {
          this.fullScreen();
          const exitFullScreenEventHandle = () => {
            this.close();
            // this.$refs['video'].removeEventListener('fullscreenchange', exitFullScreenEventHandle);
          };
          // this.$el.addEventListener('fullscreenchange', exitFullScreenEventHandle);
        }
        this.$refs['video'].play();
      },
      close() {
        this.$refs['video'].pause();
        if (isPhone()) {
          this.exitFullScreen();
        }
        this.$parent.closeVideo();
      },
      enterPIP() {  // 进入画中画模式
        this.close();
      },
      leavePIP() {  // 退出画中画模式
        
        this.$parent.showVideo();
      },
    },
    activated() {
      this.play();
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../../index.styl"
  .player {
    z-index 2001
    HStack(center)
    video {
      position relative
      height 100%
      z-index 1
      margin 0 auto
      outline 1px auto rgb(77, 144, 254)
      .closeBtn {
        height 30px
        width 30px
        position absolute
        top 0
        right 0
        background-color rgba(0, 0, 0, .5)
      }
    }
    .model {
      position fixed
      top 0
      left 0
      height 100vh
      width 100vw
      z-index -1
      background-color rgba(0, 0, 0, .5)
      backdrop-filter blur(8px)
    }
    @media (max-width screenWidth) {
      video {
        width 100%
        height auto
      }
    }
  }
</style>
